// React Lib
import React from "react";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// Material UI Core
import MUITypography from "@mui/material/Typography";
import { StyledEngineProvider } from "@mui/material";
export const Typography = (props) => {
    const { id, fontFamily = FONT_FAMILY.ROBOTO_REGULAR, size = 12, color = Color.neutral[900], style, className, onMouseOver, onMouseOut, onClick, noWrap } = props;
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(MUITypography, { id: id, style: Object.assign({ fontFamily: fontFamily, fontSize: size, color: color }, style), className: className, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onClick: onClick, noWrap: noWrap ? noWrap : false }, props.children)));
};
export default React.memo(Typography);
